import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import { getExclusionTitle, useExclusionType, useSelfExclusionData } from '@swf/account';
import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';
import { ServerMessageHandler } from '@swf/notification';

import useJumpBackAndResetDeposit from '../../../hooks/useJumpBackAndResetDeposit';
import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Back_to_homepage,
  TXTWCL_Start_a_new_deposit,
  TXTWCL_There_has_been_an_issue_with_y_ELL
} from './GlobalError.messages.json';

interface Props {
  defaultMessage: string;
  onClose(): void;
}

const GlobalError: React.FC<Props> = ({ defaultMessage, onClose }) => {
  const jumpBackAndResetDeposit = useJumpBackAndResetDeposit();
  const exitWizard = useWizardExit();
  const site = useSelector(select.cms.getSiteId);
  const isSelfExcluded = useSelector(select.account.getSelfExclusion);
  const nationalExclusion = useSelector(select.account.bannedByRegulator);
  const { selfExclusionData } = useSelfExclusionData();
  const { daysRequested } = selfExclusionData || {};
  const depositSuspended = isSelfExcluded || nationalExclusion || !!daysRequested;
  const exclusionType = useExclusionType(daysRequested, nationalExclusion);

  const getTitle = () => {
    if (depositSuspended) {
      return getExclusionTitle({
        nationalExclusion,
        site,
        daysRequested,
        exclusionType
      });
    }
    return TXTWCL_There_has_been_an_issue_with_y_ELL;
  };

  return (
    <Prompt
      variant="error"
      title={{ translation: getTitle() }}
      primaryButton={{
        translation: depositSuspended ? TXTWCL_Back_to_homepage : TXTWCL_Start_a_new_deposit
      }}
      onPrimaryButtonClick={() =>
        depositSuspended ? exitWizard() : jumpBackAndResetDeposit('#deposit.deposit-method')
      }
      onClose={onClose}
    >
      <Typography>
        <ServerMessageHandler message={defaultMessage} />
      </Typography>
    </Prompt>
  );
};

export default GlobalError;
